import React, { useState } from 'react';
import { isNil } from 'lodash';
import { generateCmsUrl } from '../../services/cms/cmsService';
import Button from '../Button.jsx';

const hiddenElementType = {
    none: 'None',
    text: 'Text',
    button: 'Button',
};

const HidingItem = ({ element }) => {
    const [hiddenImage, setHiddenImage] = useState(false);

    const handleButtonClick = (e, link) => {
        e.preventDefault();
        window.location.href = link;
    };

    const handleHideImage = () => {
        setHiddenImage(true);
    };

    const coverImage =
        !isNil(element.coverImage) &&
        !isNil(element.coverImage.data) &&
        !isNil(element.coverImage.data.attributes)
            ? element.coverImage.data.attributes
            : {};

    return element.hiddenItem === hiddenElementType.none ? (
        <div className='hiding-image-container'>
            <img
                src={generateCmsUrl(coverImage.url)}
                alt={coverImage.alternativeText}
            />
        </div>
    ) : (
        <div className='hiding-element'>
            <div
                className={`hiding-element-${element.hiddenItem.toLowerCase()}`}>
                {element.hiddenItem === hiddenElementType.text ? (
                    isNil(element.link) ? (
                        <span>{element.hiddenText}</span>
                    ) : (
                        <a
                            className='link'
                            href={element.link}
                            title={element.hiddenText}
                            target='_blank'>
                            {element.hiddenText}
                        </a>
                    )
                ) : (
                    <Button
                        className='button button--primary'
                        text={element.hiddenText}
                        onClick={(e) => {
                            handleButtonClick(e, element.link);
                        }}
                    />
                )}
            </div>
            <div
                className={`hiding-element-image ${
                    hiddenImage ? 'hidden-image' : ''
                }`.trim()}
                onClick={handleHideImage}>
                <img
                    src={generateCmsUrl(coverImage.url)}
                    alt={coverImage.alternativeText}
                />
            </div>
        </div>
    );
};

export default HidingItem;
